module.exports = __webpack_public_path__ + "static/interiors-powder-room-7d82a2ac94e40d61bcb2ae78a237b205.jpg";